import React from 'react';

/**
 * Simple line drawings for the home questions.
 * They are shapes, not photos, so a quick look tells the choices apart.
 */
export default function HomeProfileIcon({ id, color = '#0f766e' }) {
  const common = {
    width: 56,
    height: 56,
    viewBox: '0 0 56 56',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    'aria-hidden': 'true',
  };
  const stroke = { stroke: color, strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' };
  if (id === 'concrete_block') {
    return (
      <svg {...common}>
        <rect x="8" y="14" width="18" height="10" rx="1" {...stroke} />
        <rect x="30" y="14" width="18" height="10" rx="1" {...stroke} />
        <rect x="8" y="28" width="12" height="10" rx="1" {...stroke} />
        <rect x="22" y="28" width="12" height="10" rx="1" {...stroke} />
        <rect x="36" y="28" width="12" height="10" rx="1" {...stroke} />
      </svg>
    );
  }
  if (id === 'wood_frame') {
    return (
      <svg {...common}>
        <path d="M10 44 V16 H46 V44" {...stroke} />
        <path d="M18 44 V16 M28 44 V16 M38 44 V16" {...stroke} />
        <path d="M10 24 H46 M10 34 H46" {...stroke} />
      </svg>
    );
  }
  if (id === 'steel_frame') {
    return (
      <svg {...common}>
        <path d="M16 12 V44 M40 12 V44" {...stroke} />
        <path d="M12 18 H20 M12 38 H20 M36 18 H44 M36 38 H44" {...stroke} />
        <path d="M16 28 H40" {...stroke} />
      </svg>
    );
  }
  if (id === 'icf') {
    return (
      <svg {...common}>
        <rect x="10" y="14" width="36" height="28" rx="2" {...stroke} />
        <path d="M18 14 V42 M38 14 V42" {...stroke} />
        <path d="M18 28 H38" {...stroke} />
      </svg>
    );
  }
  if (id === 'manufactured') {
    return (
      <svg {...common}>
        <path d="M8 30 H48 L42 20 H14 Z" {...stroke} />
        <path d="M14 30 V40 H42 V30" {...stroke} />
        <circle cx="18" cy="42" r="3" {...stroke} />
        <circle cx="38" cy="42" r="3" {...stroke} />
      </svg>
    );
  }
  if (id === 'stucco') {
    return (
      <svg {...common}>
        <rect x="12" y="14" width="32" height="28" rx="2" {...stroke} />
        <path d="M16 24c4 2 8-2 12 0s8-2 12 0 M16 32c4 2 8-2 12 0s8-2 12 0" {...stroke} />
      </svg>
    );
  }
  if (id === 'vinyl_siding') {
    return (
      <svg {...common}>
        <path d="M12 16 H44 M12 24 H44 M12 32 H44 M12 40 H44" {...stroke} />
        <path d="M12 16 V20 M44 24 V28 M12 32 V36" {...stroke} />
      </svg>
    );
  }
  if (id === 'fiber_cement') {
    return (
      <svg {...common}>
        <path d="M14 18 H42 M14 26 H38 M18 34 H42 M14 42 H36" {...stroke} />
      </svg>
    );
  }
  if (id === 'wood_siding') {
    return (
      <svg {...common}>
        <path d="M12 18 H44 M12 28 H44 M12 38 H44" {...stroke} />
        <path d="M20 18 V28 M32 28 V38" {...stroke} />
      </svg>
    );
  }
  if (id === 'brick') {
    return (
      <svg {...common}>
        <rect x="10" y="16" width="16" height="8" {...stroke} />
        <rect x="30" y="16" width="16" height="8" {...stroke} />
        <rect x="18" y="28" width="16" height="8" {...stroke} />
        <rect x="10" y="40" width="12" height="6" {...stroke} />
        <rect x="26" y="40" width="20" height="6" {...stroke} />
      </svg>
    );
  }
  if (id === 'stone') {
    return (
      <svg {...common}>
        <path d="M12 20 L22 14 L34 20 L28 30 L14 28 Z" {...stroke} />
        <path d="M30 22 L44 18 L46 32 L34 36 Z" {...stroke} />
        <path d="M16 34 L28 36 L24 46 L12 42 Z" {...stroke} />
      </svg>
    );
  }
  if (id === 'metal') {
    return (
      <svg {...common}>
        <path d="M14 14 V42 M22 14 V42 M30 14 V42 M38 14 V42 M46 14 V42" {...stroke} />
      </svg>
    );
  }
  if (id === 'eifs') {
    return (
      <svg {...common}>
        <rect x="12" y="16" width="32" height="26" rx="2" {...stroke} />
        <path d="M12 24 H44 M12 32 H44" {...stroke} />
      </svg>
    );
  }
  if (id === 'slab') {
    return (
      <svg {...common}>
        <path d="M10 24 H46 L40 18 H16 Z" {...stroke} />
        <path d="M14 32 H42" {...stroke} />
        <path d="M8 40 H48" {...stroke} />
      </svg>
    );
  }
  if (id === 'crawl_space') {
    return (
      <svg {...common}>
        <path d="M10 26 H46 L40 16 H16 Z" {...stroke} />
        <path d="M16 26 V36 M40 26 V36" {...stroke} />
        <path d="M12 40 H44" {...stroke} />
      </svg>
    );
  }
  if (id === 'stem_wall') {
    return (
      <svg {...common}>
        <path d="M12 22 H44 L38 14 H18 Z" {...stroke} />
        <path d="M16 22 V38 H40 V22" {...stroke} />
        <path d="M10 42 H46" {...stroke} />
      </svg>
    );
  }
  if (id === 'pier_beam') {
    return (
      <svg {...common}>
        <path d="M8 24 H48" {...stroke} />
        <path d="M16 24 V42 M28 24 V42 M40 24 V42" {...stroke} />
        <path d="M12 42 H20 M24 42 H32 M36 42 H44" {...stroke} />
      </svg>
    );
  }
  if (id === 'asphalt_shingles') {
    return (
      <svg {...common}>
        <path d="M8 30 L28 12 L48 30" {...stroke} />
        <path d="M14 30 H42 M16 36 H40 M18 42 H38" {...stroke} />
      </svg>
    );
  }
  if (id === 'concrete_tile') {
    return (
      <svg {...common}>
        <path d="M8 28 L28 12 L48 28" {...stroke} />
        <path d="M16 28c4 4 8 4 12 0s8-4 12 0" {...stroke} />
        <path d="M16 36c4 4 8 4 12 0s8-4 12 0" {...stroke} />
      </svg>
    );
  }
  if (id === 'clay_tile') {
    return (
      <svg {...common}>
        <path d="M8 26 L28 12 L48 26" {...stroke} />
        <path d="M16 30c0 4 6 4 6 0 M26 30c0 4 6 4 6 0 M36 30c0 4 6 4 6 0" {...stroke} />
        <path d="M16 38c0 4 6 4 6 0 M26 38c0 4 6 4 6 0 M36 38c0 4 6 4 6 0" {...stroke} />
      </svg>
    );
  }
  if (id === 'flat_tpo') {
    return (
      <svg {...common}>
        <path d="M10 24 H46 L42 18 H14 Z" {...stroke} />
        <path d="M24 28c4 3 8 3 10 0" {...stroke} />
        <circle cx="30" cy="32" r="1.4" fill={color} />
      </svg>
    );
  }
  if (id === 'not_sure') {
    return (
      <svg {...common}>
        <circle cx="28" cy="28" r="14" {...stroke} />
        <path d="M22 24c0-3 3-5 6-5s6 2 6 5c0 4-6 4-6 8" {...stroke} />
        <circle cx="28" cy="38" r="1.3" fill={color} />
      </svg>
    );
  }
  return (
    <svg {...common}>
      <circle cx="28" cy="28" r="14" {...stroke} />
    </svg>
  );
}
